<template>
  <div class="cookie-declaration container no-padding-container text-gray-600">
    <div class="px-5">
      <div class="pt-5 md:pt-12">
        <h1 class="o-heading-1 mb-3 text-center md:mb-10" v-text="$t('Footer.CookieDeclaration')" />
      </div>
      <script
        id="CookieDeclaration"
        :data-culture="locale"
        src="https://consent.cookiebot.com/0b6e9c22-7c32-46ab-aebf-9b0cf9bf2156/cd.js"
        type="text/javascript"
        async
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CookieDeclaration',
  computed: {
    ...mapState('app', {
      locale: state => state.locale
    })
  }
}
</script>

<style scoped lang="postcss">
.cookie-declaration {
  a {
    @apply text-yellow-400 underline;
  }

  >>> a {
    @apply text-yellow-400 underline;
  }
}
</style>
